import Vue from 'vue'
import VueI18n from 'vue-i18n'

const langs = process.env.VUE_APP_SUPPORTED_LANG.split(',')
let loadedLang = {}

langs.forEach(async (lang) => {
    Object.assign(loadedLang, { [`${lang}`] : await require(`@/assets/lang/${lang}.json`) })
})

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: process.env.VUE_APP_DEFAULT_LANG,
    fallbackLocale: process.env.VUE_APP_DEFAULT_LANG,
    messages: loadedLang,
})

export default i18n
